import { Link } from "react-router-dom";
import { movies, siteStats } from "@/mocks/movies";
import SectionHeading from "@/components/feature/SectionHeading";
import MovieCard from "@/components/feature/MovieCard";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import HotRanking from "@/pages/home/components/HotRanking";
import CollectionSection from "@/pages/home/components/CollectionSection";
import { usePageMeta } from "@/hooks/usePageMeta";

const latest = [...movies].sort((a, b) => b.updatedAt.localeCompare(a.updatedAt)).slice(0, 8);

export default function Home() {
  usePageMeta(
    "诱人的女员工hd影视专区-最新电影电视剧资源推荐",
    "诱人的女员工hd影视专区为您提供相关电影电视剧的资讯与解析，涵盖剧情介绍、演员信息等内容，方便用户了解和选择喜欢的影视作品。",
  );

  return (
    <>
      <HeroCarousel />

      <section className="border-b border-background-200 bg-background-100">
        <div className="mx-auto grid w-full max-w-7xl grid-cols-2 gap-6 px-4 py-8 md:grid-cols-4 md:gap-4 md:px-6 md:py-10">
          {siteStats.map((stat) => (
            <div key={stat.label} className="flex flex-col gap-1 md:flex-row md:items-baseline md:gap-3">
              <span className="font-label text-2xl font-semibold tracking-tight text-foreground-950 md:text-3xl">
                {stat.value}
              </span>
              <span className="text-xs text-foreground-500 md:text-sm">{stat.label}</span>
            </div>
          ))}
        </div>
      </section>

      <section className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="Just Updated"
          title="最新影视"
          description="按更新时间排列的新增与更新内容，涵盖电影与电视剧，点开即可查看完整剧情与演员信息。"
          action={
            <Link
              to="/category"
              className="inline-flex items-center gap-1 rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-600 cursor-pointer whitespace-nowrap"
            >
              查看全部
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
            </Link>
          }
        />
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-6 lg:grid-cols-4">
          {latest.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </section>

      <HotRanking />

      <CollectionSection />

      <section className="mx-auto w-full max-w-7xl px-4 pb-14 md:px-6 md:pb-20">
        <div className="grid grid-cols-1 items-center gap-10 rounded-lg border border-background-200 bg-background-100 px-6 py-10 md:grid-cols-[1.15fr_1fr] md:px-10 md:py-12">
          <div>
            <span className="font-label text-[11px] uppercase tracking-[0.28em] text-accent-600">About The Site</span>
            <h2 className="mt-3 text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              一个认真做影视内容梳理的专区
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-600">
              我们把每部作品的题材、年份、主创与剧情脉络整理成统一结构，让你在决定看什么之前，先得到一个清晰的判断。
              站内所有作品资料均为示范性虚构内容，仅用于展示与参考，不提供播放、下载或会员服务。
            </p>
            <ul className="mt-6 space-y-3 text-sm text-foreground-700">
              {[
                "剧情简介与演员资料对照呈现，信息不割裂",
                "按题材、地区、年份与热度多维度筛选",
                "专题片单由编辑整理，适合按心情挑选",
              ].map((item) => (
                <li key={item} className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line mt-0.5 w-4 h-4 flex items-center justify-center text-accent-500" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
            <Link
              to="/about"
              className="mt-7 inline-flex items-center gap-2 rounded-md bg-primary-950 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-900 cursor-pointer whitespace-nowrap"
            >
              了解我们
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
            </Link>
          </div>

          <div className="grid grid-cols-2 gap-3">
            {[
              { icon: "ri-film-line", title: "电影推荐", desc: "类型片与文艺片交叉选片" },
              { icon: "ri-live-line", title: "剧集追看", desc: "按更新节奏整理连续剧" },
              { icon: "ri-user-star-line", title: "演员档案", desc: "主创信息与角色对照" },
              { icon: "ri-bookmark-3-line", title: "本地收藏", desc: "浏览器内保存想看清单" },
            ].map((item) => (
              <div key={item.title} className="rounded-lg border border-background-200 bg-background-50 p-4">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                  <i className={`${item.icon} text-base`} />
                </span>
                <h3 className="mt-3 text-sm font-medium text-foreground-950">{item.title}</h3>
                <p className="mt-1 text-xs leading-6 text-foreground-500">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}